import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
  isOpen: boolean;
  onToggle: () => void;
}
function FAQItem({
  question,
  answer,
  isOpen,
  onToggle
}: FAQItemProps) {
  return <div className="border-b border-[#2D3436]/10 last:border-b-0" data-id="element-86">
      <button onClick={onToggle} className="w-full py-5 flex items-center justify-between text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-[#5B8F7B] focus-visible:ring-offset-2 rounded-lg" aria-expanded={isOpen} data-id="element-87">
        <span className="font-medium text-[#2D3436] pr-4" data-id="element-88">{question}</span>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.2
      }} className="flex-shrink-0" data-id="element-89">
          <ChevronDownIcon className="w-5 h-5 text-[#5B8F7B]" data-id="element-90" />
        </motion.div>
      </button>
      <AnimatePresence initial={false} data-id="element-91">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} className="overflow-hidden" data-id="element-92">
            <p className="pb-5 text-[#2D3436]/70 leading-relaxed" data-id="element-93">{answer}</p>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    question: '¿Necesito comprar suplementos caros?',
    answer: 'No, todo lo que necesitas está en el supermercado común. El protocolo se basa en alimentos reales y técnicas de respiración, no en pastillas ni polvos costosos.'
  }, {
    question: '¿Es una dieta keto o ayuno?',
    answer: 'No, es un protocolo anti-inflamatorio basado en ciencia hormonal. No eliminas grupos de alimentos ni pasas hambre. Se trata de intercambios inteligentes y técnicas para calmar tu sistema nervioso.'
  }, {
    question: '¿Cuánto tiempo me quitará al día?',
    answer: 'Menos de 10 minutos en total entre la técnica de respiración (2 minutos antes de cada comida) y el ritual nocturno de drenaje (3 minutos antes de dormir).'
  }, {
    question: '¿Funciona si tengo menopausia?',
    answer: 'Sí, es especialmente efectivo cuando hay cambios hormonales drásticos. De hecho, muchas mujeres en menopausia o perimenopausia ven los mejores resultados porque sus cuerpos responden muy bien a la regulación del cortisol.'
  }, {
    question: '¿Recibo algo por correo físico?',
    answer: 'Es un producto 100% digital que recibes de inmediato en tu email. Puedes acceder desde tu teléfono, tablet o computadora en cualquier momento.'
  }, {
    question: '¿Puedo tomar café?',
    answer: 'Sí, te enseñamos cómo tomarlo sin disparar tu cortisol. No tienes que renunciar a tu café de la mañana, solo aprenderás a tomarlo de forma estratégica.'
  }];
  return <section className="w-full bg-[#FBF9F4] py-16 md:py-24" data-id="element-94">
      <div className="max-w-3xl mx-auto px-4" data-id="element-95">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.7
      }} data-id="element-96">
          <div className="text-center mb-12" data-id="element-97">
            <h2 className="font-['Playfair_Display'] text-2xl md:text-3xl lg:text-4xl font-bold text-[#2D3436] mb-4" data-id="element-98">
              Preguntas Frecuentes
            </h2>
            <p className="text-[#2D3436]/60" data-id="element-99">
              Resolvemos tus dudas antes de que empieces
            </p>
          </div>

          <div className="bg-white rounded-2xl p-6 md:p-8 shadow-sm" data-id="element-100">
            {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} isOpen={openIndex === index} onToggle={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-101" />)}
          </div>
        </motion.div>
      </div>
    </section>;
}